(function () {

    angular
        .module('smartertoolsApp')
        .controller('trackSignupForm', ['$scope', '$location', '$timeout', 'authenticationService', '$http', trackSignupForm]);

    function trackSignupForm($scope, $location, $timeout, authenticationService, $http) {
        const vm = this;
        vm.step = authenticationService.isLoggedIn() ? 'form-short' : 'form';
        vm.name = '';
        vm.email = authenticationService.getLoggedInEmail();
        vm.phone = '';
        vm.sitePrefix = '';
        vm.accountPassword = '';
        vm.confirmPassword = '';
        vm.siteNameCheckStatus = null;
        vm.namePattern = /^.*\S\s+\S.*$/;
        vm.errorMessage = '';
        vm.siteNamePattern = /^[a-zA-Z][a-zA-Z0-9-]+[a-zA-Z0-9]$/;
        vm.phonePattern =
            /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-. \\/]?)?((?:\(?\d+\)?[\-. \\/]?)*)(?:[\-. \\/]?(?:#|ext?\.?|extension|x)[\-. \\/]?(\d+))?$/i;

        // Functions
        vm.siteNameChanged = siteNameChanged;
        vm.popupLogin = popupLogin;
        vm.createAccountThenSignup = createAccountThenSignup;
        vm.startSignup = startSignup;

        activate();

        // -----------------------------------------------

        function activate() {
            $scope.$on('authentication:logged-in', () => onLoggedIn());
            $scope.$on('authentication:logged-out', () => {});
            $timeout(() => {
                if (typeof RecalculateAllFloatLabelControls == 'function') {
                    RecalculateAllFloatLabelControls();
                }
            });
        }

        function siteNameChanged() {
            if (!vm.sitePrefix) {
                vm.siteNameCheckStatus = null;
                return;
            }
            vm.siteNameCheckStatus = 0;
            $http.post(`${apiRootUrl}v1/hosted-smartertrack/availability`, JSON.stringify({SitePrefix: vm.sitePrefix}))
                .then(response => {
                    let data = response.data;
                    vm.siteNameCheckStatus = data.IsAvailable ? 1 : -1;
                    $scope.$applyAsync();
                }, () => {
                });
        }

        function onLoggedIn() {
            if (authenticationService.isLoggedIn()) {
                vm.step = 'form-short';
                vm.email = authenticationService.getLoggedInEmail();
            } else
                vm.step = 'form';

            $scope.$applyAsync();
            $timeout(() => {
                if (typeof RecalculateAllFloatLabelControls == 'function') {
                    RecalculateAllFloatLabelControls();
                }
            });
        }

        function popupLogin() {
            ShowLoginOverlay();
            return false;
        }

        function createAccountThenSignup() {
            const firstName = vm.name.split(' ').slice(0, -1).join(' ');
            const lastName = vm.name.split(' ').slice(-1).join(' ');

            if (!authenticationService.isLoggedIn()) {
                let data = {
                    FirstName: firstName,
                    LastName: lastName,
                    Company: null,
                    PhoneNumber: vm.phone,
                    EmailAddress: vm.email,
                    'Password': vm.accountPassword
                };
                let rememberMe = false;
                authenticationService.createAccount(data,
                    rememberMe,
                    err => {
                        if (!err) {
                            vm.step = 'building';
                            vm.timeStarted = new Date();
                            vm.startSignup();
                        } else {
                            let message = '';
                            if (err.Message)
                                message = err.Message;
                            else if (err.ModelState) {
                                for (let key in err.ModelState) {
                                    for (let msg in err.ModelState[key]) {
                                        if (message !== '') message += '<br/>';
                                        message += err.ModelState[key][msg];
                                    }
                                }
                            }
                            if (message === '') message = 'Generic Error';
                            if (message === 'Email address already exists' || message === 'Email address is already in use')
                                message = 'It looks like you already have a SmarterTools account.  Please log in to continue.';
                            vm.errorMessage = message;

                            $scope.$applyAsync();
                        }
                        // TODO: Show errors here
                        RefreshLoginTopArea();
                    });
            }
        }

        function startSignup() {
            $http.post(`${apiRootUrl}v1/hosted-smartertrack/build-start`, JSON.stringify({SitePrefix: vm.sitePrefix}))
                .then(response => {
                    let data = response.data;
                    if (typeof ga === 'function') {
                        ga('send', 'event', 'Hosted SmarterTrack', 'Trial', 'Hosted SmarterTrack Trial');
                    }
                    $scope.$applyAsync(() => {
                        $location.path(`/${vm.sitePrefix}/${data.ServiceSignupGuid}`);
                    });
                }, () => {
                });
        }
    }

})();